import React from "react";

interface HeaderFieldOffProps {
  size?: number | string;
  color?: string;
  className?: string;
}

export default function HeaderFieldOff({
  size = 18,
  color = "#BA72CB",
  className,
}: HeaderFieldOffProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="2.19922"
        y="4.55078"
        width="5.60069"
        height="3.15039"
        rx="1.5752"
        fill="#79808A"
      />
      <circle cx="3.77593" cy="6.12554" r="1.22515" fill="white" />
      <path
        d="M2.81563 1.8024C2.56698 1.8024 2.32853 1.89722 2.15271 2.066C1.9769 2.23479 1.87813 2.46371 1.87813 2.7024C1.87813 2.9411 1.9769 3.17001 2.15271 3.3388C2.32853 3.50758 2.56698 3.6024 2.81563 3.6024H7.19063C7.43927 3.6024 7.67772 3.50758 7.85354 3.3388C8.02935 3.17001 8.12812 2.9411 8.12812 2.7024C8.12812 2.46371 8.02935 2.23479 7.85354 2.066C7.67772 1.89722 7.43927 1.8024 7.19063 1.8024H2.81563ZM9.99688 1.2576C9.97249 0.916326 9.81405 0.596666 9.5536 0.363222C9.29314 0.129777 8.95008 -4.20131e-05 8.59375 1.01992e-08H1.40625L1.31 0.00300008C0.954507 0.0264133 0.621527 0.178509 0.378356 0.428548C0.135185 0.678587 -4.37637e-05 1.00792 1.06242e-08 1.35V10.65L0.00312508 10.7424C0.0275138 11.0837 0.185947 11.4033 0.446404 11.6368C0.706862 11.8702 1.04992 12 1.40625 12H8.59375L8.69 11.997C9.04549 11.9736 9.37847 11.8215 9.62164 11.5715C9.86481 11.3214 10 10.9921 10 10.65V1.35L9.99688 1.2576ZM1.40625 0.9H8.59375L8.6575 0.9042C8.76972 0.918989 8.87257 0.972288 8.94702 1.05424C9.02147 1.13619 9.0625 1.24126 9.0625 1.35V10.65L9.05812 10.7112C9.04272 10.8189 8.9872 10.9177 8.90183 10.9891C8.81646 11.0606 8.70702 11.1 8.59375 11.1H1.40625L1.3425 11.0958C1.23028 11.081 1.12743 11.0277 1.05298 10.9458C0.978527 10.8638 0.937505 10.7587 0.9375 10.65V1.35L0.941875 1.2888C0.95728 1.18107 1.0128 1.08233 1.09817 1.01086C1.18354 0.939386 1.29298 0.900005 1.40625 0.9Z"
        fill={color}
      />
    </svg>
  );
}
